// Components
import StripePayment from './stripe-payment'
// Types
import type {StripePayload, SubmissionObject} from '../../types/submission-wizard'

interface StripeFormPageProps {
  stripePayload: StripePayload
  paymentIsProcessing: boolean
  sendPaymentIsProcessing: (isProcessing: boolean) => void
  onCastSubmission: (submission: SubmissionObject) => Promise<boolean>
  onNext: () => void
}

const StripeFormPage = ({
  stripePayload,
  paymentIsProcessing,
  sendPaymentIsProcessing,
  onCastSubmission,
  onNext,
}: StripeFormPageProps) => {
  return (
    <StripePayment
      stripePayload={stripePayload}
      paymentIsProcessing={paymentIsProcessing}
      sendPaymentIsProcessing={sendPaymentIsProcessing}
      onCastSubmission={onCastSubmission}
      onNext={onNext}
    />
  )
}

export default StripeFormPage
